import { restClient } from '../config/restClient'

const endpoint = companyId => `/api/company/v2/company_profiles/${companyId}/analytics`

export const getDeclineReasons = async (companyId, params) => {
  const response = await restClient(`${endpoint(companyId)}/decline_reasons`, {
    method: 'GET',
    params,
  })

  return response.data
}

export const getInterviewRequests = async (companyId, params) => {
  const response = await restClient(`${endpoint(companyId)}/interview_requests`, {
    method: 'GET',
    params,
  })

  return response.data
}

export const getNewCandidates = async (companyId, params) => {
  const response = await restClient(`${endpoint(companyId)}/new_candidates`, {
    method: 'GET',
    params,
  })

  return response.data
}

export const getPositions = async companyId => {
  const response = await restClient(`${endpoint(companyId)}/job_openings`, {
    method: 'GET',
  })

  return response.data
}

export const getProfileViews = async (companyId, params) => {
  const response = await restClient(`${endpoint(companyId)}/profile_views`, {
    method: 'GET',
    params,
  })

  return response.data
}

export const getRates = async (companyId, params) => {
  const response = await restClient(`${endpoint(companyId)}/rates`, {
    method: 'GET',
    params,
  })

  return response.data
}
